BaseModel = require './base_model.coffee'

class global.Task extends BaseModel
  @ATTRIBUTES = {
    id: {}
    type: {}
    due_on: { type: Date, default: moment().add(1, 'day') }
    end_on: { type: Date, default: moment().add(1, 'day').add(1, 'hour') }
    done_at: { type: Date, default: null }
    service: {}
    comment: {}
    metadata: {}
    text: {}
    slug: {}
    referenceable_id: {}
    referenceable_type: {}
    created_by_type: {}
    undefined_time: {}
    assigned_to_id: {}
    voip_calls_count: {}
    voip_call_status: {}
    meeting_type_id: {}
    new_contact_stage: {}
  }

  @ASSOCIATIONS = {
    contact: -> Contact
    template: -> Template
    assigned_to: -> User
    meeting_type: -> MeetingType
    flow: -> Flow
  }

  @SERIALIZABLE_ATTRIBUTES = [
    'id'
    'type'
    'due_on'
    'metadata'
    'service'
    'done_at'
    'comment'
    'referenceable_type'
    'referenceable_id'
    'template'
    'undefined_time'
  ]

  @SERIALIZABLE_ASSOCIATIONS = []

  @emailTaskService = {
    service: 'ManualTasksServices::Email',
    human_name: 'E-mail',
    type: 'EmailFlowAction'
  }

  # This is hard-coded because I was unable to think of a better way for now :(
  @availableManualTaskServices = [
    @emailTaskService,
    { service: 'ManualTasksServices::Linkedin', human_name: 'LinkedIn', type: 'TaskFlowAction' },
    { service: 'ManualTasksServices::Phonecall', human_name: 'Ligação', type: 'TaskFlowAction' },
    { service: 'ManualTasksServices::Social', human_name: 'Social', type: 'TaskFlowAction' },
    { service: 'ManualTasksServices::Meeting', human_name: 'Reunião', type: 'TaskMeeting' }
  ]

  @serviceIcons = {
    'ManualTasksServices::Email': 'task-icon email-task-icon'
    'ManualTasksServices::Phonecall': 'task-icon phonecall-task-icon'
    'ManualTasksServices::Linkedin': 'task-icon linkedin-task-icon'
    'ManualTasksServices::Social': 'task-icon social-task-icon'
  }

  humanStatus: ->
    switch @voip_call_status
      when "no_connection" then "Sem conexão"
      when "gatekeeper" then "Gatekeeper"
      when "opportunity" then "Conectado"
      when "client" then "Cliente"
      when "lost" then "Perdido"
      else "Ligar para contato"

  @manualTaskService: (service) ->
    for service_options in @availableManualTaskServices
      if service_options.service == service
        return service_options

    return { service: service, human_name: '' }

  formattedDueOn: ->
    return 'Data inválida' unless @validDueOn()
    @due_on.format 'LLL'

  validDueOn: ->
    @due_on and @due_on.isValid and @due_on.isValid()

  isEmailTask: ->
    @service == 'ManualTasksServices::Email' && (@created_by_type == 'FlowAction' || @created_by_type == 'User')

  isMeetingTask: ->
    @service == 'ManualTasksServices::Meeting'

  isSocialTask: ->
    @service == 'ManualTasksServices::Social'

  isLikedinTask: ->
    @service == 'ManualTasksServices::Linkedin'

  isCreatedByUser: ->
   @created_by_type == 'User'

  isDone: ->
    @done_at and @done_at.isValid()

  isOzzyTask: ->
    @type == 'OzzyTask'

  isOverdue: ->
    !@isDone() and moment().isAfter @due_on

  isDueToday: ->
    @due_on.isSame(moment(), 'day')

  wasOzzyTask: ->
    @metadata.ozzy

  isScheduled: ->
    if(@metadata && @metadata.automatic_task_id)
      true
    else
      false

  markAsDone: ->
    return if @isDone()
    @done_at = moment()

  toggleDone: ->
    if @isDone()
      @done_at = null
    else
      @done_at = moment()

  summaryText: ->
    return '' unless @service
    Task.manualTaskService(@service).human_name

  dueOnText: ->
    return 'Selecione data e hora' unless @due_on
    return 'Data Inválida' unless @due_on && @due_on.isValid && @due_on.isValid()
    "#{@due_on.format('LLL')} (#{@due_on.fromNow()})"

  dueOnHour: ->
    moment(@due_on).format('LT')

  doneAtHour: ->
    moment(@done_at).format('LT')

  doneAtDate: ->
    moment(@done_at).format('L')

  dueOnDate: ->
    moment(@due_on).format('L')

  template_or_null: ->
    if Array.isArray(@template) then null else @template

  template_or_new: ->
    if Array.isArray(@template) then new Template(kind: @templateKind()) else @template

  hasVoipCalls: ->
    @voip_calls_count > 0

  canBeUndone: ->
    (@isCreatedByUser() || @wasOzzyTask()) && !@hasVoipCalls()

  templateKind: ->
    switch @service
      when 'ManualTasksServices::Phonecall' then 'phonecall'
      when 'ManualTasksServices::Linkedin' then 'linkedin'
      when 'ManualTasksServices::Social' then 'social'
      else 'email'



// WEBPACK FOOTER //
// ./src/models/task.coffee